import React from 'react';

function DoubleEuroIcon({ className, style }) {
  return (
    <div className={`double-euro-icon ${className || ''}`} style={style}>
      <span className="fa-stack fa-1x double-euro-icon__group-front">
        <i
          className="fas fa-circle fa-stack-2x double-euro-icon__icon-back"
          // style={{ '-webkit-text-stroke': '2px ' + color, color: bgColor }}
        />
        <i className="fas fa-euro-sign fa-stack-2x double-euro-icon__icon-front" />
      </span>
      <span className="fa-stack fa-1x  double-euro-icon__group-back">
        <i
          className="fas fa-circle fa-stack-2x  double-euro-icon__icon-back"
          // style={{ '-webkit-text-stroke': '2px ' + color, color: bgColor }}
        />
        <i className="fas fa-euro-sign fa-stack-2x double-euro-icon__icon-front" />
      </span>
    </div>
  );
}


export default DoubleEuroIcon;
